var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcQueue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.125,
    y: 6.125,
    width: 6.999,
    height: 7,
    rx: 2,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.125,
    y: 6.125,
    width: 6.999,
    height: 7,
    rx: 2,
    fill: "#979797",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1 .75.75 0 0 0 .75-.75v-3.5a1 1 0 0 1 1-1h3.5a.75.75 0 0 0 .75-.75 1 1 0 0 0-1-1h-5z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1 .75.75 0 0 0 .75-.75v-3.5a1 1 0 0 1 1-1h3.5a.75.75 0 0 0 .75-.75 1 1 0 0 0-1-1h-5z",
    fill: "#979797",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875.875a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1 .75.75 0 0 0 .75-.75v-3.5a1 1 0 0 1 1-1h3.5a.75.75 0 0 0 .75-.75 1 1 0 0 0-1-1h-5z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQueue);
export default __webpack_public_path__ + "static/media/ic-queue.6b07026341240b6a06c6eb2e32ed0dad.svg";
export { ForwardRef as ReactComponent };